import { useAuth } from './use-auth';
import { User } from '@/lib/types';

export default function useIsCurrentUser() {
  const auth = useAuth();
  return auth.user as User;
}
